import React, { useState, useEffect, useRef } from "react";
import {
  makeAjax,
  showMessage,
  url,
  respStatus,
} from "../../../../helpers/global_helper";
import { useDispatch, useSelector } from "react-redux";
import { setCommonConfig } from "../../../../redux/actions.js";
import BetSuccessPopup from "../../../Popups/BetSuccessPopup";
import ConfirmBetDeskonPopup from "../../../Popups/ConfirmBetDeskonPopup";
import ErrorInnerPopup from "../../../Popups/ErrorInnerPopup";
import ErrorPopup from "../../../Popups/ErrorPopup";
import MacauShioSuccessPopup from "../../../Popups/MacauShioSuccessPopup";
import { withTranslation } from "react-i18next";
import { getUserBalance } from "../../../../redux/actions";
import GameClosedPopup from "../GameClosedPopup.js";
import MarketClose from "../MarketClose.js";

const MacauShio = (props) => {
  const dispatch = useDispatch();
  const device = useSelector((state) => state.CommonConfig.device_type);
  const betDiscount = useSelector((state) => state.CommonConfig.discount);
  const conversion = 1000;
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errMessage, setErrorMessage] = useState("");
  const [successPopup, setSuccessPopup] = useState(false);
  const [macauoShioSuccessPopup, setMacauoShioSuccessPopup] = useState(false);
  const [respData, setRespData] = useState([]);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [rowsToShow, setRowsToShow] = useState(10);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [showTable, setShowTable] = useState(true);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const gameType =
    useSelector((state) => state.CommonConfig.gameType) ?? "4d3d2d";
  const [enabledInputs, setEnabledInputs] = useState(
    Array(rowsToShow).fill(false)
  );
  const [selectedValues, setSelectedValues] = useState(
    Array(rowsToShow).fill({ guess1: "", guess2: "", bet: "" })
  );
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);

  const [reqData, setReqData] = useState({
    gameId: gameId,
    gameType: "macaushio",
  });
  const [submitData, setSubmitData] = useState({
    gameId: gameId,
    gameType: "macaushio",
    betTogelAuth: "betTogelAuth",
    dataangka: [],
    allowPartner: "allowPartner",
  });

  useEffect(() => {
    if (Object.keys(betDiscount).length <= 0) {
      setErrorMessage("Togel Data API missing, Refresh page and try again.");
      setShowErrorPopup(true);
      return;
    }
  }, [betDiscount]);
  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };
  useEffect(() => {
    makeAjax(url.TOGEL_API.getTogelGame, reqData)
      .then((response) => {
        if (response.status !== respStatus["SUCCESS"]) {
          if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }
          if (response.code !== "validation_error") {
            setErrorMessage("Game not available", "error", "error");
            setShowErrorPopup(true);
            return;
          }
          setErrorMessage("Game not available", "error", "error");
          setShowErrorPopup(true);
          return;
        }
        setDropdownOptions(response.data.shio);
      })
      .catch((error) => {
        setErrorMessage("Repeated numbers are not allowed");
        setShowErrorPopup(true);
        return;
      });
  }, [reqData]);

  const handleFirstDropdownChange = (e, rowIndex) => {
    const newSelectedValues = [...selectedValues];
    newSelectedValues[rowIndex] = {
      ...newSelectedValues[rowIndex],
      guess1: e.target.value,
    };
    setSelectedValues(newSelectedValues);
  };

  const handleSecondDropdownChange = (e, rowIndex) => {
    // const newEnabledInputs = [...enabledInputs];
    // newEnabledInputs[rowIndex] = e.target.value !== '';
    // setEnabledInputs(newEnabledInputs);
    const newEnabledInputs = [...enabledInputs];
    newEnabledInputs[rowIndex] = e.target.value !== "";
    setEnabledInputs(newEnabledInputs);

    const newSelectedValues = [...selectedValues];
    newSelectedValues[rowIndex] = {
      ...newSelectedValues[rowIndex],
      guess2: e.target.value,
    };
    setSelectedValues(newSelectedValues);
  };

  const handleInputChange = (e, rowIndex, columnName) => {
    const value = e.target.value;

    if (!/^\d*$/.test(value)) {
      setErrorMessage("Please fill in your bet and bet amount.");
      setShowErrorPopup(true);
      return;
    }

    if (value && Number(value) < 1) {
      setErrorMessage("Minimal bet is 1");
      setShowErrorPopup(true);
      return;
    }

    // makeAjax(url.TOGEL_API.getTogelDetails, { "gameId": gameId, "gameType": "macaushio" })
    //   .then((response) => {
    //     if (value > response.data.showMax) {
    //       setErrorMessage('Your bet amount exceeds the maximum limit.');
    //       setShowErrorPopup(true);
    //       e.target.value = '';
    //       const newSelectedValues = [...selectedValues];
    //       newSelectedValues[rowIndex] = { ...newSelectedValues[rowIndex], bet: '' }; // Clear the value from selectedValues
    //       setSelectedValues(newSelectedValues);
    //       return;
    //     }
    //   })
    //   .catch((error) => {
    //     console.error("Error fetching price response:", error);
    //     setShowErrorPopup(true);
    //     setErrorMessage("Error fetching price response");
    //   });

    if (value > betDiscount.showMax / 1000) {
      setShowErrorPopup(true);
      setErrorMessage("Your bet nominal exceeds the maximum limit.");
      e.target.value = "";
      const newSelectedValues = [...selectedValues];
      newSelectedValues[rowIndex] = { ...newSelectedValues[rowIndex], bet: "" }; // Clear the value from selectedValues
      setSelectedValues(newSelectedValues);
      return;
    }

    const newSelectedValues = [...selectedValues];
    newSelectedValues[rowIndex] = {
      ...newSelectedValues[rowIndex],
      bet: e.target.value,
    };
    setSelectedValues(newSelectedValues);
  };

  const handleReset = () => {
    setSelectedValues(
      Array(rowsToShow).fill({ guess1: "", guess2: "", bet: "" })
    );
    setEnabledInputs(Array(rowsToShow).fill(false));

    const dropdowns = document.querySelectorAll(".inputs select");
    dropdowns.forEach((dropdown) => {
      dropdown.value = "";
    });

    const textInputs = document.querySelectorAll(".inputs input");
    textInputs.forEach((input) => {
      input.value = "";
      input.disabled = true;
    });
  };

  const showPopup = (event) => {
    const allEmpty = selectedValues.every(
      (value) => !value.guess1 || !value.guess2 || !value.bet
    );
    if (allEmpty) {
      setErrorMessage(props.t("macaushio_error"));
      setShowErrorPopup(true);
      return;
    }
    setShowConfirmationPopup(true);
  };

  const submitProcessOk = () => {
    setShowConfirmationPopup(false);
    const newData = [];
    for (let i = 0; i < selectedValues.length; i++) {
      if (
        selectedValues[i]["guess1"] !== "" &&
        selectedValues[i]["guess2"] !== "" &&
        selectedValues[i]["bet"] !== ""
      ) {
        const transformedKey =
          selectedValues[i]["guess1"] + "-" + selectedValues[i]["guess2"];
        const betAmount =
          selectedValues[i]["bet"] == ""
            ? ""
            : selectedValues[i]["bet"] * conversion;
        newData.push([transformedKey, betAmount.toString(), "success"]);
      }
      // else {
      //   newData.push([null, null, "null"]);
      // }
    }
    // setSubmitData(prevState => ({
    //   ...prevState,
    //   dataangka: newData
    // }));

    setSubmitData((prevState) => {
      const updatedState = {
        ...prevState,
        dataangka: newData,
      };
      // Call getApiResponse after setting the state
      getApiResponse(updatedState);
      return updatedState;
    });
  };

  const getApiResponse = (submitData) => {
    makeAjax(url.TOGEL_API.processAltTogel, submitData)
      .then((response) => {
        if (response.status !== respStatus["SUCCESS"]) {
          if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }
          if (response.code !== "validation_error") {
            setErrorMessage(props.t("macaushio_error"), "error", "error");
            setShowErrorPopup(true);
            return;
          }
          setErrorMessage(props.t("macaushio_error"), "error", "error");
          setShowErrorPopup(true);
          return;
        }
        setRespData((prevData) => [...prevData, response.data]);
        dispatch(getUserBalance());
        // setSuccessPopup(true);
        setMacauoShioSuccessPopup(true);
        setShowTable(false);
      })
      .catch((error) => {
        setShowErrorPopup(true);
        setErrorMessage("Repeated numbers are not allowed");
      });
  };

  const handleClose = () => {
    setSuccessPopup(false);
    setRespData([]);
    handleReset();
  };

  const handleMacauoShioClose = () => {
    setMacauoShioSuccessPopup(false);
    setRespData([]);
    handleReset();
  };

  return (
    <div className="colokbebasTwoD_wrapper">
      {showGameClose ? (
        <GameClosedPopup />
      ) : showMarketClose ? (
        <MarketClose />
      ) : (
        <>
          {/* --- Rules ---  */}
          <div className="rules_container">
            <div>
              <p>Guess Macau Shio from 4D</p>
              <p>Format Tarun: A*EH#bet+M*P#bet</p>
              <p>Conoth Penulisan :1*2*3#1+5*6#2</p>
            </div>
            <div className="rules_conversion">
              <p>
                Konversi <br /> 1 = {betDiscount.showMultiple}
              </p>
            </div>
          </div>
          {/* --- Rules ---  */}
          <div className="colokbebasTwoD_container">
            <table>
              <thead>
                <tr className="Heading">
                  <th>No</th>
                  <th>{props.t("guess")} 1</th>
                  <th>{props.t("guess")} 2</th>
                  <th>
                    {" "}
                    {props.t("bet")} <span className="small_input">1=1000</span>
                  </th>
                  {device === "Mobile" ? (
                    <>
                      <th>{props.t("discount")}</th>
                      <th>{props.t("pay")}</th>
                      <th></th>
                    </>
                  ) : null}
                </tr>
              </thead>
              <tbody>
                {[...Array(rowsToShow)].map((_, index) => (
                  <tr
                    key={index}
                    className={index % 2 === 0 ? "even-row" : "odd-row"}
                  >
                    <td>{index + 1}</td>
                    <td className="inputs">
                      <select
                        style={{ minWidth: 50 }}
                        onChange={(e) => handleFirstDropdownChange(e, index)}
                      >
                        <option value=""></option>
                        {dropdownOptions.map((option, idx) => (
                          <option
                            key={option.bet_type_id}
                            value={option.bet_type_id}
                          >{` ${option.name}`}</option>
                        ))}
                      </select>
                    </td>
                    <td className="inputs">
                      <select
                        style={{ minWidth: 50 }}
                        onChange={(e) => handleSecondDropdownChange(e, index)}
                      >
                        <option value=""></option>
                        {dropdownOptions.map((option, idx) => (
                          <option
                            key={option.bet_type_id}
                            value={option.bet_type_id}
                          >{` ${option.name}`}</option>
                        ))}
                      </select>
                    </td>
                    <td className="inputs">
                      <input
                        style={{ minWidth: 50 }}
                        id="betInput"
                        type="text"
                        placeholder="Bet"
                        onChange={(e) => handleInputChange(e, index, "Belli")}
                        disabled={!enabledInputs[index]}
                      />
                    </td>
                    {device === "Mobile" ? (
                      <>
                        <td>
                          <input type="text" style={{ minWidth: 20 }} />
                        </td>
                        <td>
                          <input type="text" />
                        </td>
                        <td>
                          <button className="reset-button">reset</button>
                        </td>
                      </>
                    ) : null}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="last_div">
            <div className="left_div">
              <p>{props.t("macau_shio_text_4d")}</p>
            </div>
            <div className="right_div">
              <ul className="button-list">
                <li>
                  <button className="reset" onClick={handleReset}>
                    {props.t('reset')}
                  </button>
                </li>
                <li>
                  <button className="submit" onClick={showPopup}>
                    {props.t('submit')}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </>
      )}

      {showConfirmationPopup && (
        <ConfirmBetDeskonPopup
          onClose={() => setShowConfirmationPopup(false)}
          submitProcessOk={submitProcessOk}
        />
      )}
      {/* {successPopup && (
        <div className="popup-overlay ">
          <BetSuccessPopup response={respData} onClose={handleClose} />
        </div>
      )} */}
      {macauoShioSuccessPopup && (
        <div className="popup-overlay ">
          <MacauShioSuccessPopup
            response={respData}
            onClose={handleMacauoShioClose}
          />
        </div>
      )}
      {
        /*---error popup --*/
        showErrorPopup && (
          <ErrorInnerPopup
            modalTitle={""}
            modalHeader={true}
            onCloseModal={() => setShowErrorPopup(false)}
          >
            <ErrorPopup
              message={errMessage}
              onClose={() => setShowErrorPopup(false)}
            />
          </ErrorInnerPopup>
        )
      }
    </div>
  );
};

export default withTranslation()(MacauShio);
